<template>
    <div class="row">
        <div v-for="(option, ok) in options" :key="ok"
            class="col-6 col-md-4 my-2 my-lg-4"
            >
            <img :src="'/assets/img/avatars/student/' + option + '.png'"
                tabindex="0"
                :class="{
                    'img-fluid': true,
                    'selected': option == internalValue,
                    'not-selected': option != internalValue
                }"
                alt="Avatar per l'alunno/a"
                @keyup.enter="internalValue = option"
                @click="internalValue = option">
        </div>
    </div>
</template>
<script>

export default{
    props: {
        value: String
    },
    data(){
        return {
            options: [
                '1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
                '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', 
                '21', '22', '23', '24', '25', '26', '27', '28', '29', '30',
                '31'
            ],
            internalValue: String
        }
    },
    watch:{
        internalValue(){
            window.$('#u_avatar').val(this.internalValue)
            window.$('#avatar-img').attr('src', '/assets/img/avatars/student/' + this.internalValue + '.png')
        }
    },
    mounted(){
        this.internalValue = this.value
    }
}

</script>
<style scoped>
.selected{
    border: 2px solid lightgreen;
    border-radius: 3px;
}
.not-selected{
    border: 2px solid white;
}
img {
    width: 170px;
}
</style>